import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import InvitesModal from '../Components/Modals/InvitesModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'Invites'>;

const InvitesScreen: React.FC<Props> = ({ navigation }) => {
	return <InvitesModal onClose={() => navigation.goBack()} />;
};

export default InvitesScreen;
